const USERS = 'https://algolia.com/users';

/* Global */

export const ACADEMY = 'https://academy.algolia.com/';
export const BLOG = 'https://algolia.com/blog/';
export const COMMUNITY = 'https://community.algolia.com';
export const DASHBOARD = 'https://algolia.com/dashboard';
export const DISCOURSE = 'https://discourse.algolia.com';
export const DOC = 'https://algolia.com/doc';
export const DOCSEARCH = 'https://docsearch.algolia.com';
export const GITHUB = 'https://github.com/algolia';
export const GRADER = 'https://grader.algolia.com';
export const NEWSLETTER = 'https://aloglia.com/lp/newsletter-subscription/';
export const PARTNERS = 'https://partners.algolia.com';
export const PRODUCT_TOUR = 'https://app.getreprise.com/launch/kX0Blm6/';
export const RESOURCES = 'https://resources.algolia.com';
export const SEARCH_AUDIT = 'https://go.algolia.com/SearchAudit_Retail.html';
export const STATUS = 'https://status.algolia.com';
export const STATUS_API = `${STATUS}/2/status/service/`;
export const STORIES = 'https://stories.algolia.com';
export const SUPPORT = 'https://support.algolia.com';
export const YOUTUBE = 'https://www.youtube.com';
export const ZENDESK_GET_STARTED = 'https://aloglia.com/getstarted#/zendesk';

/* Community */

export const TALKSEARCH = 'https://community.algolia.com/talksearch/';

/* Doc */

export const DOC_CHANGELOG = `${DOC}/changelog/`;
export const GETTING_STARTED = `${DOC}/guides/getting-started/how-algolia-works/`;
export const FAQ = `${DOC}/faq/`;

/* Resources */

export const CUSTOMER_STORIES = `${RESOURCES}/customer-stories`;

/* Users (dashboard) */

export const SIGN_IN = `${USERS}/sign_in`;
export const SIGN_OUT = `${USERS}/sign_out`;
export const SIGN_UP = `${USERS}/sign_up`;

/* Partners */

export const PARTNERS_REGISTRATION = `${PARTNERS}/partner-registration/`;

/* Temporary constants, remove when not used anymore */

export const AI_SEARCH_GUIDE = `${RESOURCES}/ai-search/guide-algolia-dynamic-synonyms-suggestions`;
export const ON_DEMAND_WEBINAR_AI_LAUNCH = `${RESOURCES}/webinars/webinar-ailaunch-dg`;
export const WEBINAR_MASTERCLASS = `${RESOURCES}/merchandising/webinar-masterclassvisualeditor-dg-retail`;
export const WEBINAR_SUMMER_19 = 'https://algolia.com/webinar/summer-19/';
export const WEBINAR_WINTER_20 =
  'https://resources.algolia.com/webinars/webinar-winter20release-dg ';
export const G2_GRID_REPORT = `${RESOURCES}/reports/reports-g2gridenterprisesearch`;
